<template>
	<div style="height: 84vh;">
		<div class="tenant_search">
			<div class="tenant_search_1">
				<i class="ione"></i>
				<el-input placeholder="请输入管理员名称" prefix-icon="el-icon-search" v-model="data.name" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="类别搜索" prefix-icon="el-icon-search" v-model="data.type" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="详情搜索" prefix-icon="el-icon-search" v-model="data.info" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-date-picker style="width: 100%;" v-model="data.start_time" type="date" placeholder="开始日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="handleStatusChange">
				</el-date-picker>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-date-picker style="width: 100%;" v-model="data.end_time" type="date" placeholder="结束日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="handleStatusChange">
				</el-date-picker>
			</div>

			<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;"
				:style="{ marginLeft: minw ? '1rem' : '0' ,marginRight: minw ? '1rem' : '0'}">
				<div>
					<button class="search_button" @click="search()">搜索</button>
					<button class="search_button" @click="search('重置')">重置</button>
				</div>
				<div v-show="minw" style="display: flex;align-items: center;">
					<p style="color: #909399;">{{launched?'收起':'展开'}}</p>
					<i size="mini" :class="launched?'el-icon-arrow-up':'el-icon-arrow-down'" @click="launched=!launched"></i>
				</div>

			</div>
		</div>
		<!-- 	<a :href="`http://192.168.2.110:7310/admin/bill/export?token=${token}`" download>下载文件</a> -->
		<!-- <ListingButton :lists="lists" @replenish='replenish' @export='bllisexport'></ListingButton> -->
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BannerStatus='BannerStatus' @BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete"
			@Currentchange="contractlistcontractlist" style="margin: 1rem;"></MyTable>
		<Mycell :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BannerStatus='BannerStatus' @BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete"
			@Currentchange="contractlistcontractlist" style="padding-bottom: 4rem;"></Mycell>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import Mycell from "@/components/My_cell/index.vue"
	import {
		BASEURL
	} from "@/Utils/request.js";
	import {
		operate_list,
		bill_replenish,
		bill_export,
		back_pay
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'operation_log',
				tableData: [],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '地址',
					value: 'address'
				}, {
					label: 'IP地址',
					value: 'ip'
				}, {
					label: '操作系统',
					value: 'os'
				}, {
					label: '浏览器',
					value: 'browser'
				}, {
					label: '管理员名称',
					value: 'name'
				}, {
					label: '类别',
					value: 'type'
				}, {
					label: '详情',
					value: 'info'
				}, {
					label: '操作时间',
					value: 'create_time'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15,
					name: '',
					type: '',
					info: '',
					start_time: '',
					end_time: ''
				},
				options: [{
					value: 0,
					label: '待支付'
				}, {
					value: 1,
					label: '已支付'
				}, ],
				minw: JSON.parse(sessionStorage.getItem('minw')),
				launched: !JSON.parse(sessionStorage.getItem('minw')),

			}
		},
		methods: {
			search(resetting) {

				if (resetting != undefined) {

					this.data.name = ''
					this.data.type = ''
					this.data.info = ''
					this.data.start_time = ''
					this.data.end_time = ''
					this.contractlistcontractlist(this.data.page)
				} else {
					sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 1);

					this.contractlistcontractlist('搜索')
				}
			},
			handleStatusChange() {
				sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 0);
			},
			contractlistcontractlist(value) {
				if (value == '搜索') {
					this.data.page = 1
				} else if (sessionStorage.getItem(this.$router.currentRoute.path + 'search_status') == 1) {
					this.data.page = value ? value : this.data.page
				} else {
					this.data = {
						page: value ? value : this.data.page,
						limit: 15
					}
				}
				operate_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '合同编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			async BatchDelete() {
				let res = await contract_delete({
					id: this.multipleSelection
				})
				this.Messages(res)
				this.contractlistcontractlist()

			},
			// 点击删除
			async Delete(value) {
				console.log("Delete", value.id);
				let res = await contract_delete({
					id: value.id
				})
				this.Messages(res)
				this.contractlistcontractlist()

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			async BannerStatus(value) {
				console.log(value);
				const res = await back_pay(value.id)
				this.Messages(res)
				this.contractlistcontractlist()
			},
			//补全账单
			async replenish() {
				const res = await bill_replenish();
				this.Messages(res)
				this.contractlistcontractlist()
			},
			bllisexport() {
				// BASE_URL: 'http://192.168.2.110:7310/admin/bill/export',
				const token = sessionStorage.getItem('token')
				const url = `${BASEURL}admin/bill/export?token=${token}`;

				const link = document.createElement('a');
				link.href = url;
				link.download = ''; // 可以留空让浏览器自动识别文件名，也可以指定如 'bill.xlsx'
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link); // 下载完成后移除元素

			}
		},
		components: {
			MyTable,
			ListingButton,
			Mycell
		},
		created() {
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 9rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}

	.tenant_search .tenant_search_1 {
		flex: 1 1 auto !important;
		min-width: 11rem !important;
	}

	.tenant_search .tenant_search_1:nth-last-of-type(-n + 2) {
		min-width: 12.4rem !important;
	}

	.tenant_search .tenant_search_1:nth-last-of-type(-n + 3) {
		min-width: 12.4rem !important;
	}

	.tenant_search_1 .el-select {
		width: 100% !important;
	}
</style>